/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ResolveFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { TenantKey } from '../enums/tenant-key.enum';
import { TenantState } from '../../shared/features/tenant/shared/services/tenant-state.service';
import { TenantHelper } from '../../shared/features/tenant/shared/helpers/tenant.helper';

export const tenantSetterResolver: ResolveFn<void> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): void => {
  const tenantState = inject(TenantState);
  const tenantType = route.data['tenantType'] as TenantKey;

  const tenantConfig = TenantHelper.getTenantByType(tenantType);

  tenantState.setCurrentTenant(tenantConfig);
};
